import { ViewGroupOptions } from "./SettingButton/ContextMenu";
import SettingButton from "./SettingButton/SettingButton";

interface HeaderProps {
	setViewGroups: React.Dispatch<React.SetStateAction<ViewGroupOptions[]>>;
	viewGroups: ViewGroupOptions[];
}
export default function Header(props: HeaderProps) {
	return (
		<div className="flex items-center justify-between">
			<h2 className="text-sm text-black-50 font-semibold pb-2">
				Views
			</h2>
			<div className="flex items-center gap-2">
				<SettingButton
					setViewGroups={props.setViewGroups}
					viewGroups={props.viewGroups}
				/>
			</div>
		</div>
	);
}
